import type {
  FormVariables,
  FormData,
} from '../../ContactForm/ContactFormJSON.types';

// TODO: Need to set these values for every form
const isDevSite =
  window.location.href.includes('webflow') ||
  window.location.href.includes('localhost') ||
  window.location.href.includes('127.0.0.1');

const contactFormVariables: FormVariables = {
  // endpoint: 'https://cf.wonderful.com', // Link for dev form endpoint: https://dev-cf.wonderful.com
  endpoint: isDevSite
    ? 'https://dev-cf.wonderful.com' // Link for dev form endpoint: https://dev-cf.wonderful.com
    : 'https://cf.wonderful.com',
  routingStatus: isDevSite ? 'False' : 'True', // True for prod (with capital 'T'). false for dev
  errorMessage: 'Please correct the fields in red.',
  noticeMessage: 'Please complete all fields.',
};

// This is a phone number field example
// const phoneExample = {
//   type: 'tel',
//   label: 'Your phone number',
//   name: 'phone_number', // Make sure this value is phone_number so code can do formatting on this field value when the form is submitted
//   validationMessage: 'Phone number is required',
//   required: true,
//   defaultValue: '',
//   autocomplete: 'tel',
//   size: {
//     mobile: 12,
//     tablet: 6,
//     desktop: 6,
//   },
// };

const contactReasons: FormData = {
  visibleFieldsetDependencies: [['contact_reason', 'default']],
  legend: 'Reason for contacting us',
  fields: [
    {
      type: 'select',
      label: 'Reason for contacting us',
      name: 'contact_reason',
      validationMessage: 'Contact reason must be selected',
      required: true,
      defaultValue: 'default',
      size: {
        mobile: 12,
        tablet: 12,
        desktop: 12,
      },
      optgroups: [
        {
          label: '',
          options: [
            { label: 'Please select from this list', value: 'default' },
            { label: 'Product Feedback', value: 'Product Feedback' },
            { label: 'General Feedback', value: 'General Feedback' },
            { label: 'Public Relation Inquiries', value: 'PR Inquiries' },
            { label: 'Other Questions', value: 'Other Questions' },
          ],
        },
      ],
    },
  ],
};

const commonFields: FormData = {
  visibleFieldsetDependencies: [['contact_reason', 'default']],
  legend: 'Your Details',
  fields: [
    {
      type: 'text',
      label: 'First Name',
      name: 'first_name',
      placeholder: 'First Name',
      validationMessage: 'Please enter first name',
      required: true,
      defaultValue: '',
      autocomplete: 'given-name',
      size: {
        mobile: 12,
        tablet: 6,
        desktop: 6,
      },
    },
    {
      type: 'text',
      label: 'Last Name',
      name: 'last_name',
      placeholder: 'Last Name',
      validationMessage: 'Please enter last name',
      required: true,
      defaultValue: '',
      autocomplete: 'family-name',
      size: {
        mobile: 12,
        tablet: 6,
        desktop: 6,
      },
    },
  ],
};

const emailFields: FormData = {
  visibleFieldsetDependencies: [['contact_reason', 'default']],
  legend: 'Email Address',
  fields: [
    {
      type: 'email',
      label: 'Email Address',
      name: 'user_email',
      placeholder: 'Email Address',
      validationMessage: 'Please enter a valid email',
      required: true,
      defaultValue: '',
      autocomplete: 'email',
      size: {
        mobile: 12,
        tablet: 6,
        desktop: 6,
      },
    },
    {
      type: 'email',
      label: 'Confirm Email',
      name: 'confirm_email',
      placeholder: 'Confirm Email',
      validationMessage: 'Please enter a valid email',
      required: true,
      defaultValue: '',
      autocomplete: 'confirm email',
      size: {
        mobile: 12,
        tablet: 6,
        desktop: 6,
      },
    },
  ],
};

const addressFields: FormData = {
  visibleFieldsetDependencies: [['contact_reason', 'Product Feedback']],
  legend: 'Address',
  fields: [
    {
      type: 'text',
      label: 'Street Address',
      name: 'street_1',
      placeholder: 'Street Address',
      validationMessage: 'Please enter street address',
      required: true,
      defaultValue: '',
      autocomplete: 'address-line1',
      size: {
        mobile: 12,
        tablet: 6,
        desktop: 6,
      },
    },
    {
      type: 'text',
      label: 'City',
      name: 'city',
      placeholder: 'City',
      validationMessage: 'Please enter city',
      required: true,
      defaultValue: '',
      autocomplete: 'address-level2',
      size: {
        mobile: 12,
        tablet: 6,
        desktop: 6,
      },
    },
    {
      type: 'text',
      label: 'Zip',
      name: 'zip_code',
      placeholder: 'Zip',
      validationMessage: 'Please enter zip',
      required: true,
      defaultValue: '',
      autocomplete: 'postal-code',
      size: {
        mobile: 12,
        tablet: 6,
        desktop: 6,
      },
    },
    {
      type: 'select',
      label: 'Country',
      name: 'country',
      validationMessage: 'Please enter a valid country',
      required: true,
      defaultValue: '',
      autocomplete: 'country-name',
      size: {
        mobile: 12,
        tablet: 6,
        desktop: 6,
      },
      optgroups: [
        {
          label: '',
          options: [
            { label: 'Select Country', value: '' },
            { label: 'Afghanistan', value: 'AF' },
            { label: 'Åland Islands', value: 'AX' },
            { label: 'Albania', value: 'AL' },
            { label: 'Algeria', value: 'DZ' },
            { label: 'American Samoa', value: 'AS' },
            { label: 'Andorra', value: 'AD' },
            { label: 'Angola', value: 'AO' },
            { label: 'Anguilla', value: 'AI' },
            { label: 'Antarctica', value: 'AQ' },
            { label: 'Antigua and Barbuda', value: 'AG' },
            { label: 'Argentina', value: 'AR' },
            { label: 'Armenia', value: 'AM' },
            { label: 'Aruba', value: 'AW' },
            { label: 'Australia', value: 'AU' },
            { label: 'Austria', value: 'AT' },
            { label: 'Azerbaijan', value: 'AZ' },
            { label: 'Bahamas', value: 'BS' },
            { label: 'Bahrain', value: 'BH' },
            { label: 'Bangladesh', value: 'BD' },
            { label: 'Barbados', value: 'BB' },
            { label: 'Belarus', value: 'BY' },
            { label: 'Belgium', value: 'BE' },
            { label: 'Belize', value: 'BZ' },
            { label: 'Benin', value: 'BJ' },
            { label: 'Bermuda', value: 'BM' },
            { label: 'Bhutan', value: 'BT' },
            { label: 'Bolivia', value: 'BO' },
            { label: 'Bonaire, Sint Eustatius and Saba', value: 'BQ' },
            { label: 'Bosnia and Herzegovina', value: 'BA' },
            { label: 'Botswana', value: 'BW' },
            { label: 'Bouvet Island', value: 'BV' },
            { label: 'Brazil', value: 'BR' },
            { label: 'British Indian Ocean Territory', value: 'IO' },
            { label: 'Brunei', value: 'BN' },
            { label: 'Bulgaria', value: 'BG' },
            { label: 'Burkina Faso', value: 'BF' },
            { label: 'Burundi', value: 'BI' },
            { label: 'Cabo Verde', value: 'CV' },
            { label: 'Cambodia', value: 'KH' },
            { label: 'Cameroon', value: 'CM' },
            { label: 'Canada', value: 'CA' },
            { label: 'Cayman Islands', value: 'KY' },
            { label: 'Central African Republic', value: 'CF' },
            { label: 'Chad', value: 'TD' },
            { label: 'Chile', value: 'CL' },
            { label: 'China', value: 'CN' },
            { label: 'Christmas Island', value: 'CX' },
            { label: 'Cocos (Keeling) Islands', value: 'CC' },
            { label: 'Colombia', value: 'CO' },
            { label: 'Comoros', value: 'KM' },
            { label: 'Congo', value: 'CG' },
            { label: 'Congo (the Democratic Republic of the)', value: 'CD' },
            { label: 'Cook Islands', value: 'CK' },
            { label: 'Costa Rica', value: 'CR' },
            { label: "Côte d'Ivoire", value: 'CI' },
            { label: 'Croatia', value: 'HR' },
            { label: 'Cuba', value: 'CU' },
            { label: 'Curaçao', value: 'CW' },
            { label: 'Cyprus', value: 'CY' },
            { label: 'Czechia', value: 'CZ' },
            { label: 'Denmark', value: 'DK' },
            { label: 'Djibouti', value: 'DJ' },
            { label: 'Dominica', value: 'DM' },
            { label: 'Dominican Republic', value: 'DO' },
            { label: 'Ecuador', value: 'EC' },
            { label: 'Egypt', value: 'EG' },
            { label: 'El Salvador', value: 'SV' },
            { label: 'Equatorial Guinea', value: 'GQ' },
            { label: 'Eritrea', value: 'ER' },
            { label: 'Estonia', value: 'EE' },
            { label: 'Eswatini', value: 'SZ' },
            { label: 'Ethiopia', value: 'ET' },
            { label: 'Falkland Islands [Malvinas]', value: 'FK' },
            { label: 'Faroe Islands', value: 'FO' },
            { label: 'Fiji', value: 'FJ' },
            { label: 'Finland', value: 'FI' },
            { label: 'France', value: 'FR' },
            { label: 'French Guiana', value: 'GF' },
            { label: 'French Polynesia', value: 'PF' },
            { label: 'French Southern Territories', value: 'TF' },
            { label: 'Gabon', value: 'GA' },
            { label: 'Gambia', value: 'GM' },
            { label: 'Georgia', value: 'GE' },
            { label: 'Germany', value: 'DE' },
            { label: 'Ghana', value: 'GH' },
            { label: 'Gibraltar', value: 'GI' },
            { label: 'Greece', value: 'GR' },
            { label: 'Greenland', value: 'GL' },
            { label: 'Grenada', value: 'GD' },
            { label: 'Guadeloupe', value: 'GP' },
            { label: 'Guam', value: 'GU' },
            { label: 'Guatemala', value: 'GT' },
            { label: 'Guernsey', value: 'GG' },
            { label: 'Guinea', value: 'GN' },
            { label: 'Guinea-Bissau', value: 'GW' },
            { label: 'Guyana', value: 'GY' },
            { label: 'Haiti', value: 'HT' },
            { label: 'Heard Island and McDonald Islands', value: 'HM' },
            { label: 'Holy See', value: 'VA' },
            { label: 'Honduras', value: 'HN' },
            { label: 'Hong Kong', value: 'HK' },
            { label: 'Hungary', value: 'HU' },
            { label: 'Iceland', value: 'IS' },
            { label: 'India', value: 'IN' },
            { label: 'Indonesia', value: 'ID' },
            { label: 'Iran', value: 'IR' },
            { label: 'Iraq', value: 'IQ' },
            { label: 'Ireland', value: 'IE' },
            { label: 'Isle of Man', value: 'IM' },
            { label: 'Israel', value: 'IL' },
            { label: 'Italy', value: 'IT' },
            { label: 'Jamaica', value: 'JM' },
            { label: 'Japan', value: 'JP' },
            { label: 'Jersey', value: 'JE' },
            { label: 'Jordan', value: 'JO' },
            { label: 'Kazakhstan', value: 'KZ' },
            { label: 'Kenya', value: 'KE' },
            { label: 'Kiribati', value: 'KI' },
            { label: 'Kuwait', value: 'KW' },
            { label: 'Kyrgyzstan', value: 'KG' },
            { label: 'Laos', value: 'LA' },
            { label: 'Latvia', value: 'LV' },
            { label: 'Lebanon', value: 'LB' },
            { label: 'Lesotho', value: 'LS' },
            { label: 'Liberia', value: 'LR' },
            { label: 'Libya', value: 'LY' },
            { label: 'Liechtenstein', value: 'LI' },
            { label: 'Lithuania', value: 'LT' },
            { label: 'Luxembourg', value: 'LU' },
            { label: 'Macao', value: 'MO' },
            { label: 'Macedonia', value: 'MK' },
            { label: 'Madagascar', value: 'MG' },
            { label: 'Malawi', value: 'MW' },
            { label: 'Malaysia', value: 'MY' },
            { label: 'Maldives', value: 'MV' },
            { label: 'Mali', value: 'ML' },
            { label: 'Malta', value: 'MT' },
            { label: 'Marshall Islands', value: 'MH' },
            { label: 'Martinique', value: 'MQ' },
            { label: 'Mauritania', value: 'MR' },
            { label: 'Mauritius', value: 'MU' },
            { label: 'Mayotte', value: 'YT' },
            { label: 'Mexico', value: 'MX' },
            { label: 'Micronesia (Federated States of)', value: 'FM' },
            { label: 'Moldova', value: 'MD' },
            { label: 'Monaco', value: 'MC' },
            { label: 'Mongolia', value: 'MN' },
            { label: 'Montenegro', value: 'ME' },
            { label: 'Montserrat', value: 'MS' },
            { label: 'Morocco', value: 'MA' },
            { label: 'Mozambique', value: 'MZ' },
            { label: 'Myanmar', value: 'MM' },
            { label: 'Namibia', value: 'NA' },
            { label: 'Nauru', value: 'NR' },
            { label: 'Nepal', value: 'NP' },
            { label: 'Netherlands', value: 'NL' },
            { label: 'New Caledonia', value: 'NC' },
            { label: 'New Zealand', value: 'NZ' },
            { label: 'Nicaragua', value: 'NI' },
            { label: 'Niger', value: 'NE' },
            { label: 'Nigeria', value: 'NG' },
            { label: 'Niue', value: 'NU' },
            { label: 'Norfolk Island', value: 'NF' },
            { label: 'North Korea', value: 'KP' },
            { label: 'Northern Mariana Islands', value: 'MP' },
            { label: 'Norway', value: 'NO' },
            { label: 'Oman', value: 'OM' },
            { label: 'Pakistan', value: 'PK' },
            { label: 'Palau', value: 'PW' },
            { label: 'Palestine, State of', value: 'PS' },
            { label: 'Panama', value: 'PA' },
            { label: 'Papua New Guinea', value: 'PG' },
            { label: 'Paraguay', value: 'PY' },
            { label: 'Peru', value: 'PE' },
            { label: 'Philippines', value: 'PH' },
            { label: 'Pitcairn', value: 'PN' },
            { label: 'Poland', value: 'PL' },
            { label: 'Portugal', value: 'PT' },
            { label: 'Puerto Rico', value: 'PR' },
            { label: 'Qatar', value: 'QA' },
            { label: 'Réunion', value: 'RE' },
            { label: 'Romania', value: 'RO' },
            { label: 'Russia', value: 'RU' },
            { label: 'Rwanda', value: 'RW' },
            { label: 'Saint Barthélemy', value: 'BL' },
            {
              label: 'Saint Helena, Ascension and Tristan da Cunha',
              value: 'SH',
            },
            { label: 'Saint Kitts and Nevis', value: 'KN' },
            { label: 'Saint Lucia', value: 'LC' },
            { label: 'Saint Martin (French part)', value: 'MF' },
            { label: 'Saint Pierre and Miquelon', value: 'PM' },
            { label: 'Saint Vincent and the Grenadines', value: 'VC' },
            { label: 'Samoa', value: 'WS' },
            { label: 'San Marino', value: 'SM' },
            { label: 'Sao Tome and Principe', value: 'ST' },
            { label: 'Saudi Arabia', value: 'SA' },
            { label: 'Senegal', value: 'SN' },
            { label: 'Serbia', value: 'RS' },
            { label: 'Seychelles', value: 'SC' },
            { label: 'Sierra Leone', value: 'SL' },
            { label: 'Singapore', value: 'SG' },
            { label: 'Sint Maarten (Dutch part)', value: 'SX' },
            { label: 'Slovakia', value: 'SK' },
            { label: 'Slovenia', value: 'SI' },
            { label: 'Solomon Islands', value: 'SB' },
            { label: 'Somalia', value: 'SO' },
            { label: 'South Africa', value: 'ZA' },
            {
              label: 'South Georgia and the South Sandwich Islands',
              value: 'GS',
            },
            { label: 'South Korea', value: 'KR' },
            { label: 'South Sudan', value: 'SS' },
            { label: 'Spain', value: 'ES' },
            { label: 'Sri Lanka', value: 'LK' },
            { label: 'Sudan', value: 'SD' },
            { label: 'Suriname', value: 'SR' },
            { label: 'Svalbard and Jan Mayen', value: 'SJ' },
            { label: 'Sweden', value: 'SE' },
            { label: 'Switzerland', value: 'CH' },
            { label: 'Syria', value: 'SY' },
            { label: 'Taiwan', value: 'TW' },
            { label: 'Tajikistan', value: 'TJ' },
            { label: 'Tanzania', value: 'TZ' },
            { label: 'Thailand', value: 'TH' },
            { label: 'Timor-Leste', value: 'TL' },
            { label: 'Togo', value: 'TG' },
            { label: 'Tokelau', value: 'TK' },
            { label: 'Tonga', value: 'TO' },
            { label: 'Trinidad and Tobago', value: 'TT' },
            { label: 'Tunisia', value: 'TN' },
            { label: 'Turkey', value: 'TR' },
            { label: 'Turkmenistan', value: 'TM' },
            { label: 'Turks and Caicos Islands', value: 'TC' },
            { label: 'Tuvalu', value: 'TV' },
            { label: 'Uganda', value: 'UG' },
            { label: 'Ukraine', value: 'UA' },
            { label: 'United Arab Emirates', value: 'AE' },
            { label: 'United Kingdom', value: 'GB' },
            { label: 'United States', value: 'US' },
            { label: 'United States Minor Outlying Islands', value: 'UM' },
            { label: 'Uruguay', value: 'UY' },
            { label: 'Uzbekistan', value: 'UZ' },
            { label: 'Vanuatu', value: 'VU' },
            { label: 'Venezuela', value: 'VE' },
            { label: 'Vietnam', value: 'VN' },
            { label: 'Virgin Islands (British)', value: 'VG' },
            { label: 'Virgin Islands (U.S.)', value: 'VI' },
            { label: 'Wallis and Futuna', value: 'WF' },
            { label: 'Western Sahara', value: 'EH' },
            { label: 'Yemen', value: 'YE' },
            { label: 'Zambia', value: 'ZM' },
            { label: 'Zimbabwe', value: 'ZW' },
          ],
        },
      ],
    },
    {
      type: 'select',
      label: 'Province',
      name: 'province',
      validationMessage: 'Please enter a valid Province',
      required: true,
      defaultValue: '',
      visibleFieldDependencies: [['country', 'AU']],
      size: {
        mobile: 12,
        tablet: 6,
        desktop: 6,
      },
      optgroups: [
        {
          label: '',
          options: [
            { label: 'Province', value: '' },
            { label: 'New South Wales', value: 'New South Wales' },
            { label: 'Northern Territory', value: 'Northern Territory' },
            { label: 'Queensland', value: 'Queensland' },
            { label: 'South Australia', value: 'South Australia' },
            { label: 'Tasmania', value: 'Tasmania' },
            { label: 'Victoria', value: 'Victoria' },
            { label: 'Western Australia', value: 'Western Australia' },
          ],
        },
      ],
    },
    {
      type: 'select',
      label: 'Province',
      name: 'province',
      validationMessage: 'Please enter a valid Province',
      required: true,
      defaultValue: '',
      visibleFieldDependencies: [['country', 'CA']],
      size: {
        mobile: 12,
        tablet: 6,
        desktop: 6,
      },
      optgroups: [
        {
          label: '',
          options: [
            { label: 'Province', value: '' },
            { label: 'Alberta', value: 'Alberta' },
            { label: 'British Columbia', value: 'British Columbia' },
            { label: 'Manitoba', value: 'Manitoba' },
            { label: 'New Brunswick', value: 'New Brunswick' },
            {
              label: 'Newfoundland and Labrador',
              value: 'Newfoundland and Labrador',
            },
            { label: 'Northwest Territories', value: 'Northwest Territories' },
            { label: 'Nova Scotia', value: 'Nova Scotia' },
            { label: 'Nunavut', value: 'Nunavut' },
            { label: 'Ontario', value: 'Ontario' },
            { label: 'Prince Edward Island', value: 'Prince Edward Island' },
            { label: 'Quebec', value: 'Quebec' },
            { label: 'Saskatchewan', value: 'Saskatchewan' },
            { label: 'Yukon', value: 'Yukon' },
            { label: 'Other', value: 'Other' },
          ],
        },
      ],
    },
    {
      type: 'select',
      label: 'State',
      name: 'state',
      validationMessage: 'Please enter a valid state',
      required: true,
      defaultValue: '',
      visibleFieldDependencies: [['country', 'US']],
      size: {
        mobile: 12,
        tablet: 6,
        desktop: 6,
      },
      optgroups: [
        {
          label: '',
          options: [
            { label: 'State', value: '' },
            { label: 'Alabama', value: 'AL' },
            { label: 'Alaska', value: 'AK' },
            { label: 'Arizona', value: 'AZ' },
            { label: 'Arkansas', value: 'AR' },
            { label: 'California', value: 'CA' },
            { label: 'Colorado', value: 'CO' },
            { label: 'Connecticut', value: 'CT' },
            { label: 'Delaware', value: 'DE' },
            { label: 'District Of Columbia', value: 'DC' },
            { label: 'Florida', value: 'FL' },
            { label: 'Georgia', value: 'GA' },
            { label: 'Hawaii', value: 'HI' },
            { label: 'Idaho', value: 'ID' },
            { label: 'Illinois', value: 'IL' },
            { label: 'Indiana', value: 'IN' },
            { label: 'Iowa', value: 'IA' },
            { label: 'Kansas', value: 'KS' },
            { label: 'Kentucky', value: 'KY' },
            { label: 'Louisiana', value: 'LA' },
            { label: 'Maine', value: 'ME' },
            { label: 'Maryland', value: 'MD' },
            { label: 'Massachusetts', value: 'MA' },
            { label: 'Michigan', value: 'MI' },
            { label: 'Minnesota', value: 'MN' },
            { label: 'Mississippi', value: 'MS' },
            { label: 'Missouri', value: 'MO' },
            { label: 'Montana', value: 'MT' },
            { label: 'Nebraska', value: 'NE' },
            { label: 'Nevada', value: 'NV' },
            { label: 'New Hampshire', value: 'NH' },
            { label: 'New Jersey', value: 'NJ' },
            { label: 'New Mexico', value: 'NM' },
            { label: 'New York', value: 'NY' },
            { label: 'North Carolina', value: 'NC' },
            { label: 'North Dakota', value: 'ND' },
            { label: 'Ohio', value: 'OH' },
            { label: 'Oklahoma', value: 'OK' },
            { label: 'Oregon', value: 'OR' },
            { label: 'Pennsylvania', value: 'PA' },
            { label: 'Rhode Island', value: 'RI' },
            { label: 'South Carolina', value: 'SC' },
            { label: 'South Dakota', value: 'SD' },
            { label: 'Tennessee', value: 'TN' },
            { label: 'Texas', value: 'TX' },
            { label: 'Utah', value: 'UT' },
            { label: 'Vermont', value: 'VT' },
            { label: 'Virginia', value: 'VA' },
            { label: 'Washington', value: 'WA' },
            { label: 'West Virginia', value: 'WV' },
            { label: 'Wisconsin', value: 'WI' },
            { label: 'Wyoming', value: 'WY' },
          ],
        },
      ],
    },
  ],
};

const productFeedbackFieldRelatedProduct: FormData = {
  visibleFieldsetDependencies: [['contact_reason', 'Product Feedback']],
  legend: 'Related Product',
  fields: [
    {
      type: 'select',
      label: 'Related Product',
      name: 'flavor',
      validationMessage: 'Please select an option',
      required: true,
      defaultValue: '',
      size: {
        mobile: 12,
        tablet: 12,
        desktop: 12,
      },
      optgroups: [
        {
          options: [
            {
              label: 'Please select a product from the list',
              value: '',
            },
          ],
        },
        {
          label: '',
          options: [
            {
              label: 'Wonderful Halos 1lb Bag',
              value: 'Wonderful Halos 1lb Bag',
            },
            {
              label: 'Wonderful Halos 2lb Bag',
              value: 'Wonderful Halos 2lb Bag',
            },
            {
              label: 'Wonderful Halos 3lb Bag',
              value: 'Wonderful Halos 3lb Bag',
            },
            {
              label: 'Wonderful Halos 5lb Bag',
              value: 'Wonderful Halos 5lb Bag',
            },
            {
              label: 'Wonderful Halos 5lb Box',
              value: 'Wonderful Halos 5lb Box',
            },
          ],
        },
      ],
    },
  ],
};

const productFeedbackFieldsProductUPC: FormData = {
  visibleFieldsetDependencies: [['contact_reason', 'Product Feedback']],
  legend: 'Product UPC',
  fields: [
    {
      type: 'text', // use "text" because browser native "number" doesn't support maxlength
      label: 'Product UPC',
      name: 'product_upc',
      placeholder: 'Enter the 10 digit number under barcode',
      validationMessage: 'Please enter 10 digit number under barcode',
      required: true,
      defaultValue: '',
      maxLength: 10,
      size: {
        mobile: 12,
        tablet: 12,
        desktop: 12,
      },
    },
  ],
};

const productFeedbackFieldsLotCode: FormData = {
  visibleFieldsetDependencies: [['contact_reason', 'Product Feedback']],
  legend: 'Production Code',
  fields: [
    {
      type: 'text', // use "text" because browser native "number" doesn't support maxlength
      label: 'Production Code',
      name: 'production_code',
      placeholder:
        'Enter the 11-character code found below the Pack Date on the bag',
      validationMessage:
        'Please enter the 11-character code found below the Pack Date on the bag',
      required: true,
      defaultValue: '',
      maxLength: 13,
      size: {
        mobile: 12,
        tablet: 12,
        desktop: 12,
      },
    },
  ],
};

const messageField: FormData = {
  visibleFieldsetDependencies: [['contact_reason', 'default']],
  legend: 'Your message',
  fields: [
    {
      type: 'textarea',
      label: 'Message',
      name: 'message',
      placeholder: 'Message',
      validationMessage: 'Please enter a valid message',
      defaultValue: '',
      required: true,
      maxLength: 1000,
      size: {
        mobile: 12,
        tablet: 12,
        desktop: 12,
      },
    },
  ],
};

const legalCheckboxFields: FormData = {
  visibleFieldsetDependencies: [['contact_reason', 'default']],
  legend: '',
  fields: [
    {
      type: 'checkbox',
      label:
        "I have read and agree to the <a href='/privacy-policy'>Privacy Policy</a> and <a href='/terms-of-use'>Terms of Use</a>.",
      name: 'accept_legal',
      validationMessage: 'This field is required.',
      required: true,
      size: {
        mobile: 12,
        tablet: 12,
        desktop: 12,
      },
    },
  ],
};

const hiddenFields: FormData = {
  visibleFieldsetDependencies: [['contact_reason', 'default']],
  legend: '',
  fields: [
    {
      type: 'hidden',
      label: 'Form ID',
      name: 'form_id',
      validationMessage: 'Please enter form id',
      required: true,
      defaultValue: 'halosfun_contact',
      size: {
        mobile: 12,
        tablet: 6,
        desktop: 6,
      },
    },
  ],
};

export const ContactFormJSON = {
  formId: 'halosfun_contact',
  formVariables: contactFormVariables,
  data: [
    contactReasons,
    productFeedbackFieldRelatedProduct,
    productFeedbackFieldsProductUPC,
    productFeedbackFieldsLotCode,
    commonFields,
    emailFields,
    addressFields,
    messageField,
    legalCheckboxFields,
    hiddenFields,
  ],
};

export default ContactFormJSON;
// export {};
